<template>
    <div v-if="events.length > 0" id="schedule-items-container">
        <div v-for="group in groups" class="item-group">
            {{ group.name }}
            <div v-for="event in group.events" :key="event.event_id" class="schedule-item">
                <span class="event-time" @click="showEditPopover($event, event)">{{ formatTime(event.name) }}</span>
                <slot :event="event"></slot>
                <i class="delete-icon fa fa-trash text-danger" @click="$emit('eventdelete', event)"></i>
            </div>
        </div>
        <G2Popover ref="popoverRef">
            <template #default="{ content }">
                <div class="d-flex align-items-center p-1">
                    <input type="datetime-local" :value="schedule_update ? schedule_update : content.name" @change="e => schedule_update = e.target.value" />
                    <button class="btn btn-hub-primary btn-sm ml-2" style="border-radius: 5px;" @click="() => handleReschedule(content)">Reschedule</button>
                </div>
            </template>
        </G2Popover>
    </div>
</template>

<script>
import moment from 'moment';
import G2Popover from '../../Utilities/G2Popover.vue'

export default {
    components: { G2Popover },
    emits: ['eventdelete', 'reschedule'],
    props: {
        events: Array
    },
    data() {
        return {
            groups: [],
            schedule_update: null
        };
    },
    watch: {
        events: {
            handler(newEvents) {
                let groupsObject = {};
                this.groups = [];
                if (newEvents) {
                    const dateFormat = 'dddd, MMMM DD YYYY';
                    newEvents.forEach(event => {
                        const date = moment(event.name).format(dateFormat);
                        if (groupsObject[date]) {
                            groupsObject[date].push(event);
                        }
                        else
                            groupsObject[date] = [event];
                    });
                    for (let groupName in groupsObject) {
                        this.groups.push({
                            name: groupName,
                            events: groupsObject[groupName].sort((a, b) => moment(a.name).isBefore(moment(b.name)) ? -1 : 1)
                        });
                    }
                    this.groups.sort((a, b) => moment(a.name, dateFormat).isBefore(moment(b.name, dateFormat)) ? -1 : 1);
                }
            },
            immediate: true
        }
    },
    methods: {
        formatTime(datestring) {
            const date = moment(datestring);
            return date.format('hh:mm a');
        },
        showEditPopover(e, event) {
            this.schedule_update = null
            this.$refs.popoverRef.show({ top: e.clientY, left: e.clientX }, event)
        },
        handleReschedule(event) {
            this.$emit('reschedule', event, this.schedule_update)
            this.$refs.popoverRef.close()
        },
    }
}
</script>


<style scoped>
#schedule-items-container {
    border: 1px solid #ccc;
    overflow-y: scroll;
}

.item-group {
    background-color: #eef;
    padding: 0.4rem;
    padding-bottom: 0.8rem;
    border-top: 1px solid #eee;
}
.item-group:nth-child(2n) {
    background-color: #fff;
}
.schedule-item {
    display: flex;
    align-items: center;
    justify-content: start;
    background-color: #036;
    color: white;
    margin: 0.25rem 0.5rem;
    padding: 0.25rem 0.5rem;
    border-radius: 5px;
}

.schedule-item .delete-icon {
    margin-left: auto;
    display: none;
}

.schedule-item:hover .delete-icon {
    display: initial;
}
.schedule-item .event-time:hover, .schedule-item .delete-icon:hover {
    cursor: pointer;
}
</style>